module.exports = __webpack_public_path__ + "img/ma.1edfd13e.png";